/* eslint-disable no-unreachable */
import { KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import moment from 'moment';
import React, { Component } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';
import { USER_STATUS } from 'helpers/const';
import { isPordalProperty } from 'helpers/propertyHelper';
// import UtilityCheckbox from 'components/UtilityForm/UtilityCheckbox';
import environment from '../../environments/environment';
import { authService } from '../../services/authService';
import { calendarService } from '../../services/calendarService';
import { LoaderContext } from '../../components/common/Loader/Loader';
import { getPropertyBasicInfo } from '../../services/propertyService';
import { sendEmail } from '../../services/emailService';
import '../Calendar/Calendar.scss';
import './Account.scss';
import GuestDetailCard from './GuestDetailCard';

export class BlockOffDateForm extends Component {
  stayingMembersOptions = [
    { key: 'stayingMemberOwnerOnly', value: 1 },
    { key: 'stayingMemberFriendsFamily', value: 2 },
    { key: 'stayingMemberOwnerAndFriends', value: 3 },
  ];

  constructor(props, context) {
    super(props, context);
    this.initializeValidator();
    this.props.setPageTitle(this.props.t('blockOffDate'));
    this.minFromTime = '15:00';
    this.maxToTime = '11:00';
    this.originalToDate = moment(this.props.selectedDate).add(1, 'days').format('YYYY-MM-DD');
    this.state = {
      propertyId: props.match.params.propertyId,
      fromDate: moment(this.props.selectedDate).format('YYYY-MM-DD'),
      fromTime: moment(this.minFromTime, environment.timeFormatRU),
      toDate: moment(this.props.selectedDate).add(1, 'days').format('YYYY-MM-DD'),
      toTime: moment(this.maxToTime, environment.timeFormatRU),
      accessCard: '',
      note: '',
      errorMessage: '',
      reservations: this.props.reservations,
      stayingMember: 1,
      occupancy: 1,
      guestDetails: [],
      showGuestErrors: false,
    };
    this.minDate = moment().format('YYYY-MM-DD');
    this.loadedReservationMonths = new Set();
    this.reservationMonthRequests = {};
    if (props.calendarMonthKey && props.reservations?.length) {
      this.loadedReservationMonths.add(props.calendarMonthKey);
    }
    this.getProperty();
    this.accessCardValues = [
      'accessCardQuestionRequireBoth',
      'accessCardQuestionRequireKeys',
      'accessCardQuestionRequireCard',
      'accessCardQuestionRequireNone',
    ];
  }

  componentDidMount() {
    if (this.props.selectedReservation) {
      this.setEditMode();
    }
    this.prefetchReservationMonths(
      [moment(this.state.fromDate, 'YYYY-MM-DD'), moment(this.state.toDate, 'YYYY-MM-DD')],
      { includeNeighbors: true }
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.reservations !== this.props.reservations) {
      if (this.props.calendarMonthKey) {
        this.loadedReservationMonths.add(this.props.calendarMonthKey);
      }
      this.setState((prev) => ({
        reservations: this.mergeReservations(
          this.props.reservations || [],
          prev.reservations || []
        ),
      }));
    }
    if (prevProps.calendarMonthKey !== this.props.calendarMonthKey && this.props.calendarMonthKey) {
      this.loadedReservationMonths.add(this.props.calendarMonthKey);
    }
  }

  onSendClick = (event) => {
    event.preventDefault();
    this.clearErrorMessages();
    const { valid } = this.checkIsPastReservation();

    if (this.validator.allValid() && valid) {
      if (Number(this.state.stayingMember) !== 1) {
        if (!this.validateGuestDetails()) {
          this.setState({ showGuestErrors: true });

          return;
        }
      }

      const isOnNoticePeriod = this.checkForNoticePeriod();
      if (isOnNoticePeriod) return;
      const blockOffDataPromise = this.convertAndValidate();
      blockOffDataPromise.then((blockOffData) => {
        if (blockOffData.valid) {
          if (this.props.selectedReservation) {
            this.updateBlockOffDate(blockOffData);
          } else {
            this.blockOffDate(blockOffData);
          }
        } else {
          this.showMessagesAndUpdate(blockOffData);
        }
      });
    } else {
      if (Number(this.state.stayingMember) !== 1) {
        this.setState({ showGuestErrors: true });
      }
      this.showMessagesAndUpdate();
    }
  };

  onCancelReservationClick = async () => {
    const { setLoaderVisibility } = this.context;
    const userStatus = localStorage.getItem(USER_STATUS);

    this.clearErrorMessages();
    const { valid, shouldCancel } = this.checkIsPastReservation();
    if (!valid || !shouldCancel)
      this.setState({ errorMessage: this.props.t('cancelPreviousReservedDate') });

    if (valid && shouldCancel) {
      const isOnNoticePeriod = this.checkForNoticePeriod();
      if (isOnNoticePeriod) return;
      setLoaderVisibility(true);

      if (
        this.state.isPordal === 1 &&
        (authService.currentUser.isPordalUser || userStatus === 'pordal' || userStatus === 'both')
      ) {
        const selectedReservation = this.getReservationsList().find(
          ({ id }) => id === this.props.selectedReservation
        );
        const unblockDateResult = await calendarService.unblockDatePordal(
          this.props.selectedReservation,
          this.state.pordalId,
          selectedReservation?.start,
          selectedReservation?.end,
          this.state.occupancy
        );

        if (unblockDateResult.success) {
          this.sendEmailFunc(this.props.t('ownerBlockedDateRemoved'));
        } else {
          this.setState({
            errorMessage: unblockDateResult.message || this.props.t('errorWhileBlocking'),
          });
          setLoaderVisibility(false);
        }
      } else {
        calendarService
          .unblockDate(this.props.selectedReservation)
          .then(() => {
            this.sendEmailFunc(this.props.t('ownerBlockedDateRemoved'));
          })
          .catch((error) => {
            this.setState({
              errorMessage: error,
            });
            setLoaderVisibility(false);
          });
      }
    }
  };

  onChangeHandler = (event) => {
    const { name, value } = event.target;

    if (name === 'stayingMember') {
      const numValue = Number(value);
      this.setState({
        stayingMember: numValue,
        // Reset guest state when switching back to "Owner Only" (value 1)
        ...(numValue === 1 && {
          guestDetails: [],
          showGuestErrors: false,
        }),
      });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleGuestDetailsChange = (guestDetails) => {
    this.setState({ guestDetails, showGuestErrors: false });
  };

  onTimeFromChange = (options) => {
    this.setState({
      fromTime: options,
    });
  };

  onTimeToChange = (options) => {
    this.setState({
      toTime: options,
    });
  };

  getMinDate() {
    const now = moment(); // Current time
    const fromDate = moment(this.state.fromDate, 'YYYY-MM-DD'); // Ensure correct format
    const fromTime = this.state.fromTime
      ? this.state.fromTime.format(environment.timeFormat)
      : '03:00 PM'; // Default time if undefined
    const fromDateTime = moment(
      `${fromDate.format('YYYY-MM-DD')} ${fromTime}`,
      'YYYY-MM-DD hh:mm A'
    ); // Construct full datetime

    const today = moment().format('YYYY-MM-DD'); // Today's date
    const todayAt3PM = moment().set({ hour: 15, minute: 0, second: 0, millisecond: 0 }); // 3:00 PM today
    const tomorrow = moment().add(1, 'day').format('YYYY-MM-DD'); // Tomorrow's date

    return now.isBefore(fromDateTime) && now.isBefore(todayAt3PM) ? today : tomorrow; // Allow today only before check-in time
  }

  getMinToDate() {
    const fromDate = moment(this.state.fromDate, 'YYYY-MM-DD');
    const today = moment(this.minDate, 'YYYY-MM-DD');

    return moment.max(fromDate, today).format('YYYY-MM-DD');
  }

  async setEditMode() {
    const { setLoaderVisibility } = this.context;
    setLoaderVisibility(true);
    try {
      const reservationResult = await calendarService.getOwnerReservation(
        this.props.selectedReservation
      );
      if (reservationResult.success) {
        const reservation = reservationResult;
        const fromDateTime = moment(reservation.checkIn || reservation.start);
        const toDateTime = moment(reservation.checkOut || reservation.end);

        let guestDetails = [];
        if (reservation.guests && Array.isArray(reservation.guests)) {
          const files = reservation.file || [];
          guestDetails = reservation.guests.map((guest, index) => {
            const guestFile = files.find((f) => f.guest_id === guest.id);

            return {
              ...guest,
              id: guest.id || index + 1,
              fullName: guest.fullName || '',
              idFile: guestFile ? guestFile.file : null,
            };
          });
        }

        this.setState({
          fromDate: fromDateTime.format('YYYY-MM-DD'),
          fromTime: fromDateTime,
          toDate: toDateTime.format('YYYY-MM-DD'),
          toTime: toDateTime,
          note: reservation.note,
          occupancy: reservation.occupancy || 1,
          stayingMember: reservation.stayingMember || 1,
          guestDetails,
        });
      } else {
        this.setState({ errorMessage: reservationResult.message });
      }
    } catch (error) {
      this.setState({ errorMessage: error.message || 'Error fetching reservation details' });
    } finally {
      setLoaderVisibility(false);
    }
  }

  getProperty() {
    const { setLoaderVisibility } = this.context;
    setLoaderVisibility(true);
    getPropertyBasicInfo(this.props.propertyId)
      .then((res) => {
        this.setState({
          propertyName: res.title,
          nickname: res.nickname,
          isPordal: Number(res.is_pordal),
          pordalId: res.pordal_id,
          isTerminate: Number(res.is_terminate),
          npEndDate: res.np_end_date,
          npStartDate: res.np_start_date,
        });
        setLoaderVisibility(false);
      })
      .catch(() => {
        setLoaderVisibility(false);
        swal(this.props.t('properties:propertyNotFoundError')).then(() => {
          window.location.replace('/#/properties');
        });
      });
  }

  getBlockModel(valid, message, fromDateTime, toDateTime) {
    const { note, guestDetails, stayingMember } = this.state;

    const files = [];
    const mappedGuests = guestDetails.map((guest) => {
      const isNewGuest = !Number.isNaN(Number(guest.id)); // New guests have numeric IDs generated in GuestDetailCard
      const hasNewFile = guest.idFile && typeof guest.idFile !== 'string';

      const guestObj = {
        fullName: guest.fullName,
        idType: guest.idType || 'PASSPORT',
      };

      if (!isNewGuest) {
        guestObj.id = guest.id;
        if (hasNewFile) {
          guestObj.replaceDocument = true;
        }
      }

      if (hasNewFile) {
        files.push(guest.idFile);
      }

      return guestObj;
    });

    return {
      valid,
      message,
      propertyId: this.state.propertyId,
      note,
      fromDateTime,
      toDateTime,
      stayingMember,
      guests: mappedGuests,
      files,
    };
  }

  getReservations(fromDateTime, toDateTime, forceUpdate = false) {
    const startOfCalendar = moment(fromDateTime).format('YYYY-MM-DD');
    const endOfCalendar = moment(toDateTime).format('YYYY-MM-DD');

    const getReservationsPromise = calendarService.getReservations(
      this.state.propertyId,
      startOfCalendar,
      endOfCalendar,
      forceUpdate
    );
    const getBlockedDaysPromise = calendarService.getBlockedDays(
      this.state.propertyId,
      startOfCalendar,
      endOfCalendar,
      this.props.t('ownerBlocked'),
      forceUpdate
    );

    const promises = [getReservationsPromise, getBlockedDaysPromise];

    if (isPordalProperty(this.state.propertyId)) {
      promises.push(
        calendarService.getOwnerPordalReservations(
          this.props.t('ownerBlocked'),
          this.state.propertyId,
          moment(fromDateTime).format('YYYY-MM')
        )
      );
    }

    return Promise.all(promises);
  }

  onFromDateChange = (date) => {
    if (!date || !date.isValid()) {
      return;
    }

    const value = date.format('YYYY-MM-DD');
    const { toDate: currentToDate } = this.state;
    let toDate = currentToDate;

    if (moment(value).isAfter(moment(currentToDate), 'day')) {
      toDate = moment(value).add(1, 'days').format('YYYY-MM-DD');
    }

    if (this.isFromDateBooked(value, toDate)) {
      this.setState({
        errorMessage: this.props.t('dateSelectionShouldBeInFreeTime'),
      });

      return;
    }

    this.clearErrorMessages();
    this.setState({ fromDate: value, toDate });
  };

  onToDateChange = (date) => {
    if (!date || !date.isValid()) {
      return;
    }

    const value = date.format('YYYY-MM-DD');

    if (this.isToDateBooked(value)) {
      this.setState({
        errorMessage: this.props.t('dateSelectionShouldBeInFreeTime'),
      });

      return;
    }

    this.clearErrorMessages();
    this.setState({ toDate: value });
  };

  onCheckinPickerMonthChange = (date) => {
    if (date) {
      this.prefetchReservationMonths([date], { includeNeighbors: true });
    }
  };

  onDatePickerOpen = () => {
    this.prefetchReservationMonths(
      [moment(this.state.fromDate, 'YYYY-MM-DD'), moment(this.state.toDate, 'YYYY-MM-DD')],
      { includeNeighbors: true }
    );
  };

  getReservationsList() {
    return this.mergeReservations(this.state.reservations || [], this.props.reservations || []);
  }

  getMonthKey(monthMoment) {
    return monthMoment.format('YYYY-MM');
  }

  clearErrorMessages = () => {
    this.setState({ errorMessage: '' });
  };

  validateGuestDetails = () => {
    const { guestDetails } = this.state;
    if (guestDetails.length === 0) return false;

    return guestDetails.every((guest) => {
      const hasFullName = !!guest.fullName;
      const hasSpaceInName = guest.fullName && guest.fullName.trim().includes(' ');
      const hasIdFile = !!guest.idFile;
      const isIdFileValid =
        typeof guest.idFile === 'string' || guest.validationStatus?.idFile?.success;

      return hasFullName && hasSpaceInName && hasIdFile && isIdFileValid;
    });
  };

  prefetchReservationMonths(monthMoments, { includeNeighbors = false } = {}) {
    const monthsToLoad = [];

    monthMoments.forEach((monthMoment) => {
      if (!monthMoment?.isValid()) {
        return;
      }

      monthsToLoad.push(monthMoment);

      if (includeNeighbors) {
        monthsToLoad.push(monthMoment.clone().subtract(1, 'month'));
        monthsToLoad.push(monthMoment.clone().add(1, 'month'));
      }
    });

    monthsToLoad.forEach((monthMoment) => {
      this.loadReservationsForMonth(monthMoment);
    });
  }

  parseReservationMonthResults(results) {
    const [guestReservations, blockedDays, pordalResult] = results;
    let incoming = [...guestReservations, ...blockedDays];

    if (pordalResult?.success) {
      const withoutDupes = incoming.filter((item) =>
        pordalResult.items.every(({ id }) => id !== item.id)
      );
      incoming = [...pordalResult.items, ...withoutDupes];
    }

    return incoming;
  }

  loadReservationsForMonth(monthMoment) {
    if (!monthMoment || !monthMoment.isValid()) {
      return Promise.resolve();
    }

    const monthKey = this.getMonthKey(monthMoment);

    if (this.loadedReservationMonths.has(monthKey)) {
      return Promise.resolve();
    }

    if (this.reservationMonthRequests[monthKey]) {
      return this.reservationMonthRequests[monthKey];
    }

    const monthStart = monthMoment.clone().startOf('month');
    const monthEnd = monthMoment.clone().endOf('month');

    const request = this.getReservations(monthStart.toDate(), monthEnd.toDate(), false)
      .then((results) => {
        const incoming = this.parseReservationMonthResults(results);

        this.loadedReservationMonths.add(monthKey);
        delete this.reservationMonthRequests[monthKey];

        this.setState((prev) => ({
          reservations: this.mergeReservations(incoming, prev.reservations || []),
        }));

        return incoming;
      })
      .catch(() => {
        delete this.reservationMonthRequests[monthKey];
      });

    this.reservationMonthRequests[monthKey] = request;

    return request;
  }

  mergeReservations(incoming = [], existing = []) {
    const merged = new Map();

    [...existing, ...incoming].forEach((item) => {
      if (!item) {
        return;
      }

      const key =
        item.id ||
        (item.rendering === 'background'
          ? `bg-${item.start}-${item.end}`
          : `${item.start}-${item.end}-${item.title || ''}`);

      merged.set(key, item);
    });

    return Array.from(merged.values());
  }

  buildFromDateTime(fromDateStr = this.state.fromDate, fromTime = this.state.fromTime) {
    return moment(
      `${fromDateStr} ${fromTime.format(environment.timeFormat)}`,
      'YYYY-MM-DD hh:mm A'
    ).toDate();
  }

  buildToDateTime(toDateStr = this.state.toDate, toTime = this.state.toTime) {
    const setNextDay =
      toTime &&
      moment(this.maxToTime, environment.timeFormat).isBefore(
        moment(toTime.format(environment.timeFormat), environment.timeFormat)
      );

    return this.generateToDate(
      toDateStr,
      moment(this.maxToTime, environment.timeFormat),
      toTime,
      setNextDay
    );
  }

  reservationOverlapsStayRange(reservation, fromDateTime, toDateTime) {
    const reservationStart = new Date(reservation.start).getTime();
    const reservationEnd = new Date(reservation.end).getTime();

    return reservationStart < toDateTime.getTime() && reservationEnd > fromDateTime.getTime();
  }

  hasBookedDatesInRange(
    fromDateStr,
    toDateStr,
    fromTime = this.state.fromTime,
    toTime = this.state.toTime
  ) {
    if (!fromDateStr || !toDateStr || !fromTime || !toTime) {
      return false;
    }

    const fromDateTime = this.buildFromDateTime(fromDateStr, fromTime);
    const toDateTime = this.buildToDateTime(toDateStr, toTime);

    if (toDateTime.getTime() <= fromDateTime.getTime()) {
      return false;
    }

    return this.getReservationsList().some(
      (reservation) =>
        this.isDifferentReservation(reservation) &&
        this.reservationOverlapsStayRange(reservation, fromDateTime, toDateTime)
    );
  }

  isCalendarUnavailableDay(dateStr) {
    if (!dateStr) {
      return false;
    }

    const day = moment(dateStr, 'YYYY-MM-DD').startOf('day');

    return this.getReservationsList().some((item) => {
      if (item.rendering !== 'background' || !item.start || !item.end) {
        return false;
      }

      const rangeStart = moment(item.start, 'YYYY-MM-DD', true).isValid()
        ? moment(item.start, 'YYYY-MM-DD', true)
        : moment(item.start);
      const rangeEnd = moment(item.end, 'YYYY-MM-DD', true).isValid()
        ? moment(item.end, 'YYYY-MM-DD', true)
        : moment(item.end);
      rangeStart.startOf('day');
      rangeEnd.startOf('day');

      return day.isSameOrAfter(rangeStart) && day.isBefore(rangeEnd);
    });
  }

  isReservationDateOccupied(dateStr, reservation) {
    const day = moment(dateStr, 'YYYY-MM-DD').startOf('day');
    const checkIn = moment(reservation.start);
    const checkOut = moment(reservation.end);
    const checkInDay = checkIn.clone().startOf('day');
    const checkOutDay = checkOut.clone().startOf('day');
    const checkinSlot = day.clone().hour(15).minute(0).second(0).millisecond(0);

    if (day.isBefore(checkInDay, 'day') || day.isAfter(checkOutDay, 'day')) {
      return false;
    }

    if (day.isSame(checkOutDay, 'day')) {
      return checkOut.isAfter(checkinSlot);
    }

    if (day.isSame(checkInDay, 'day')) {
      return checkIn.isSameOrBefore(checkinSlot);
    }

    return day.isAfter(checkInDay, 'day') && day.isBefore(checkOutDay, 'day');
  }

  isCheckinMomentBooked(dateStr) {
    if (!dateStr) {
      return false;
    }

    return this.getReservationsList().some(
      (reservation) =>
        this.isDifferentReservation(reservation) &&
        reservation.rendering !== 'background' &&
        this.isReservationDateOccupied(dateStr, reservation)
    );
  }

  isCheckinDateReservable(dateStr) {
    if (!dateStr) {
      return false;
    }

    if (moment(dateStr).isBefore(moment(this.getMinDate()), 'day')) {
      return false;
    }

    return !this.isCheckinMomentBooked(dateStr) && !this.isCalendarUnavailableDay(dateStr);
  }

  isCheckinDateDisabled(day) {
    if (!day || !day.isValid()) {
      return true;
    }

    return !this.isCheckinDateReservable(day.format('YYYY-MM-DD'));
  }

  isReservationCheckoutOccupied(dateStr, reservation) {
    const day = moment(dateStr, 'YYYY-MM-DD').startOf('day');
    const checkIn = moment(reservation.start);
    const checkOut = moment(reservation.end);
    const checkInDay = checkIn.clone().startOf('day');
    const checkOutDay = checkOut.clone().startOf('day');
    const checkoutSlot = day.clone().hour(11).minute(0).second(0).millisecond(0);

    if (day.isBefore(checkInDay, 'day') || day.isAfter(checkOutDay, 'day')) {
      return false;
    }

    if (day.isSame(checkOutDay, 'day')) {
      return checkOut.isSameOrAfter(checkoutSlot);
    }

    if (day.isSame(checkInDay, 'day')) {
      return checkIn.isBefore(checkoutSlot);
    }

    return day.isAfter(checkInDay, 'day') && day.isBefore(checkOutDay, 'day');
  }

  isCheckoutMomentBooked(dateStr) {
    if (!dateStr) {
      return false;
    }

    return this.getReservationsList().some(
      (reservation) =>
        this.isDifferentReservation(reservation) &&
        reservation.rendering !== 'background' &&
        this.isReservationCheckoutOccupied(dateStr, reservation)
    );
  }

  isFromDateBooked(dateStr) {
    if (!dateStr) {
      return false;
    }

    // Match check-in picker: only the selected day must be reservable as check-in.
    // Full-stay overlap is validated on submit; checkout still uses hasBookedDatesInRange.
    return !this.isCheckinDateReservable(dateStr);
  }

  isToDateBooked(dateStr, fromDateStr = this.state.fromDate) {
    if (!dateStr) {
      return false;
    }

    return this.isCheckoutMomentBooked(dateStr) || this.hasBookedDatesInRange(fromDateStr, dateStr);
  }

  checkForNoticePeriod() {
    const setNextDay = this.shouldExtendReservation();
    const toDateTime = this.generateToDate(
      this.state.toDate,
      moment(this.maxToTime, environment.timeFormat),
      this.state.toTime,
      setNextDay
    );
    const fromDateTime = moment(
      `${this.state.fromDate} ${this.state.fromTime.format(environment.timeFormat)}`,
      'YYYY-MM-DD hh:mm A'
    ).toDate();

    if (this.state?.isTerminate === 1) {
      const startDate = new Date(this.state.npStartDate);
      const endDate = new Date(this.state.npEndDate);

      const isWithinNoticePeriod =
        (fromDateTime >= startDate && toDateTime <= endDate) || // Completely within notice period
        (fromDateTime <= startDate && toDateTime >= endDate) || // Spans across notice period
        (fromDateTime >= startDate && fromDateTime <= endDate) || // Starts within notice period
        (toDateTime >= startDate && toDateTime <= endDate); // Ends within notice period

      if (isWithinNoticePeriod) {
        this.setState({
          errorMessage: this.props.t('noticePeriodError'),
        });

        return true;
      }
    }

    return false;
  }

  shouldGetOtherMonths(fromDateTime, toDateTime) {
    return (
      fromDateTime.getMonth() !== this.props.selectedDate.getMonth() ||
      toDateTime.getMonth() !== this.props.selectedDate.getMonth() ||
      this.props.selectedDate.getFullYear() !== fromDateTime.getFullYear() ||
      this.props.selectedDate.getFullYear() !== toDateTime.getFullYear()
    );
  }

  checkIsPastReservation() {
    const setNextDay = this.shouldExtendReservation();

    const toDateTime = this.generateToDate(
      this.state.toDate,
      moment(this.maxToTime, environment.timeFormat),
      this.state.toTime,
      setNextDay
    );

    const fromDateTime = moment(
      `${this.state.fromDate} ${this.state.fromTime.format(environment.timeFormat)}`,
      'YYYY-MM-DD hh:mm A'
    ).toDate();

    const fromDate = new Date(fromDateTime);
    const toDate = new Date(toDateTime);

    const currentDate = new Date();

    if (fromDate < currentDate && toDate < currentDate) {
      this.setState({ errorMessage: this.props.t('previousReservedDate') });

      return {
        valid: false,
        message: this.props.t('previousReservedDate'),
        shouldCancel: true,
      };
    }

    return {
      valid: true,
      shouldCancel: !(currentDate >= fromDate && currentDate <= toDate),
    };
  }

  checkIfDateTimeInFreeTime(reservations, fromDateTime, toDateTime) {
    if (!this.dateTimeInFreeTime(reservations, fromDateTime, toDateTime)) {
      return {
        valid: false,
        message: this.props.t('dateSelectionShouldBeInFreeTime'),
      };
    }

    return {
      valid: true,
    };
  }

  convertAndValidate() {
    const setNextDay = this.shouldExtendReservation();

    const fromDateTime = moment(
      `${this.state.fromDate} ${this.state.fromTime.format(environment.timeFormat)}`,
      'YYYY-MM-DD hh:mm A'
    ).toDate();
    this.originalToDate = this.generateToDate(
      this.state.toDate,
      moment(this.maxToTime, environment.timeFormat),
      this.state.toTime,
      false
    );
    const toDateTime = this.generateToDate(
      this.state.toDate,
      moment(this.maxToTime, environment.timeFormat),
      this.state.toTime,
      setNextDay
    );

    return new Promise((resolve, reject) => {
      if (!this.toDateTimeIsBiggerThanFrom(fromDateTime, toDateTime)) {
        resolve(
          this.getBlockModel(
            false,
            this.props.t('toDatetimeCannotBeBiggerThanFromDatetime'),
            fromDateTime,
            toDateTime
          )
        );

        return;
      }
      if (!this.shouldGetOtherMonths(fromDateTime, toDateTime)) {
        const { valid, message } = this.checkIfDateTimeInFreeTime(
          this.getReservationsList(),
          fromDateTime,
          toDateTime
        );
        resolve(this.getBlockModel(valid, message, fromDateTime, toDateTime));

        return;
      }
      this.getReservations(fromDateTime, toDateTime, true)
        .then((results) => {
          const allReservations = this.parseReservationMonthResults(results);

          const { valid, message } = this.checkIfDateTimeInFreeTime(
            allReservations,
            fromDateTime,
            toDateTime
          );
          resolve(this.getBlockModel(valid, message, fromDateTime, toDateTime));
        })
        .catch(() => {
          reject();
        });
    });
  }

  shouldExtendReservation() {
    return (
      this.state.toTime &&
      moment(this.maxToTime, environment.timeFormat).isBefore(
        moment(this.state.toTime.format(environment.timeFormat), environment.timeFormat)
      )
    );
  }

  generateToDate(toDate, maxToTime, toTime, setNextDay) {
    return moment(
      `${toDate} ${moment(setNextDay ? maxToTime : toTime).format(environment.timeFormat)}`,
      'YYYY-MM-DD hh:mm A'
    )
      .add(setNextDay ? 1 : 0, 'day')
      .toDate();
  }

  formatGuestDetails(isHtml = true) {
    const { guestDetails, stayingMember } = this.state;
    if (Number(stayingMember) === 1 || guestDetails.length === 0) return '';

    const friendsFamilyLabel = this.props.t('friendsFamilyIdentificationDetails');
    let details = isHtml
      ? `<br /><strong>${friendsFamilyLabel}:</strong><br />`
      : `\n${friendsFamilyLabel}:\n`;

    guestDetails.forEach((guest, index) => {
      const guestPrefix = isHtml ? `Guest ${index + 1}: ` : `Guest ${index + 1}: `;

      if (isHtml) {
        details += `${guestPrefix}${guest.fullName} - File: ${guest.idFile?.name || 'N/A'}<br />`;
      } else {
        details += `${guestPrefix}${guest.fullName} - File: ${guest.idFile?.name || 'N/A'}\n`;
      }
    });

    return details;
  }

  async sendEmailFunc(text, create = false) {
    const { setLoaderVisibility } = this.context;
    const user = authService.currentUser;
    const subject = `${this.state.nickname} - ${this.state.propertyName} - ${text}`;
    let body = `${this.props.t('from')}: ${this.state.fromDate} ${moment(
      this.state.fromTime
    ).format(environment.timeFormat)} <br />`;
    body += `${this.props.t('to')}: ${this.state.toDate} ${this.state.toTime.format(
      environment.timeFormat
    )} <br />`;
    if (create) {
      body += `${this.props.t('accessCardQuestion')}: ${this.props.t(
        this.state.accessCard
      )} <br />`;
    }
    body += `${this.props.t('note')}: ${this.state.note} <br />`;
    body += this.formatGuestDetails(true);
    try {
      await sendEmail(user, subject, body);
    } catch (err) {
      console.error(err);
    }
    this.props.closeSelector();
    setLoaderVisibility(false);
  }

  initializeValidator() {
    this.validator = new SimpleReactValidator({
      className: 'invalid-field',
      validators: {
        timeBiggerOrEqual: {
          rule: (val, [minDate, minTime]) => {
            const minDateTime = moment(
              `${minDate} ${moment(minTime, environment.timeFormat).format(
                environment.timeFormat
              )}`,
              'YYYY-MM-DD hh:mm A'
            );
            const currentDateTime = moment(
              `${minDate} ${moment(val).format(environment.timeFormat)}`,
              'YYYY-MM-DD hh:mm A'
            );

            return currentDateTime.isSameOrAfter(minDateTime);
          },
        },

        timeLessOrEqual: {
          rule: (val, [maxDate, maxTime]) => {
            const maxDateTime = moment(
              `${maxDate} ${moment(maxTime, environment.timeFormat).format(
                environment.timeFormat
              )}`,
              'YYYY-MM-DD hh:mm A'
            );
            const currentDateTime = moment(
              `${maxDate} ${moment(val).format(environment.timeFormat)}`,
              'YYYY-MM-DD hh:mm A'
            );

            return currentDateTime.isSameOrBefore(maxDateTime);
          },
        },

        fromDateNotBooked: {
          rule: (val) => !this.isFromDateBooked(val),
        },

        toDateNotBooked: {
          rule: (val) => !this.isToDateBooked(val),
        },
      },
    });
  }

  dateTimeInFreeTime(reservations, fromDateTime, toDateTime) {
    return !reservations.some(
      (reservation) =>
        this.isDifferentReservation(reservation) &&
        this.reservationOverlapsStayRange(reservation, fromDateTime, toDateTime)
    );
  }

  isDifferentReservation(reservation) {
    return this.props.selectedReservation
      ? this.props.selectedReservation !== reservation.id
      : true;
  }

  toDateTimeIsBiggerThanFrom(fromDateTime, toDateTime) {
    return toDateTime.getTime() - fromDateTime.getTime() > 0;
  }

  async updateBlockOffDate(blockOffData) {
    const { setLoaderVisibility } = this.context;
    let { note } = blockOffData;
    const userStatus = localStorage.getItem(USER_STATUS);

    setLoaderVisibility(true);
    if (!moment(this.originalToDate).isSame(blockOffData.toDateTime)) {
      note += `\n${this.props.t('originalCheckoutDate')}: ${moment(this.originalToDate).format(
        'YYYY-MM-DD hh:mm A'
      )}`;
    }
    if (
      this.state.isPordal === 1 &&
      (authService.currentUser.isPordalUser || userStatus === 'pordal' || userStatus === 'both')
    ) {
      const blockDateResult = await calendarService.editBlockedDatePordal(
        this.props.selectedReservation,
        moment(blockOffData.fromDateTime).format('YYYY-MM-DD HH:mm:00'),
        moment(blockOffData.toDateTime).format('YYYY-MM-DD HH:mm:00'),
        this.state.pordalId,
        this.state.occupancy,
        note,
        blockOffData.stayingMember,
        blockOffData.guests,
        blockOffData.files
      );

      if (blockDateResult.success) {
        this.sendEmailFunc(this.props.t('ownerBlockedDateEdited'));
      } else {
        this.setState({
          errorMessage: blockDateResult.message || this.props.t('errorWhileBlocking'),
        });
        setLoaderVisibility(false);
      }
    } else {
      calendarService
        .editBlockedDate(
          this.props.selectedReservation,
          moment(blockOffData.fromDateTime).format('YYYY-MM-DD HH:mm:00'),
          moment(blockOffData.toDateTime).format('YYYY-MM-DD HH:mm:00'),
          blockOffData.propertyId,
          note,
          blockOffData.toDateTime,
          blockOffData.stayingMember,
          blockOffData.guests,
          blockOffData.files
        )
        .then(() => {
          this.sendEmailFunc(this.props.t('ownerBlockedDateEdited'));
        })
        .catch((error) => {
          this.setState({
            errorMessage:
              error?.response?.data?.error?.message ||
              error?.response?.data?.message ||
              this.props.t('errorWhileBlocking'),
          });
          setLoaderVisibility(false);
        });
    }
  }

  async blockOffDate(blockOffData) {
    const { setLoaderVisibility } = this.context;
    const userStatus = localStorage.getItem(USER_STATUS);

    setLoaderVisibility(true);
    let { note } = blockOffData;
    note += `\n${this.props.t('accessCardQuestion')}: ${this.props.t(this.state.accessCard)}`;
    if (!moment(this.originalToDate).isSame(blockOffData.toDateTime)) {
      note += `\n${this.props.t('originalCheckoutDate')}: ${moment(this.originalToDate).format(
        'YYYY-MM-DD hh:mm A'
      )}`;
    }
    if (
      this.state.isPordal === 1 &&
      (authService.currentUser.isPordalUser || userStatus === 'pordal' || userStatus === 'both')
    ) {
      const blockDateResult = await calendarService.blockDatePordal(
        moment(blockOffData.fromDateTime).format('YYYY-MM-DD HH:mm:00'),
        moment(blockOffData.toDateTime).format('YYYY-MM-DD HH:mm:00'),
        this.state.pordalId,
        this.state.occupancy,
        note,
        blockOffData.stayingMember,
        blockOffData.guests,
        blockOffData.files
      );

      if (blockDateResult.success) {
        this.sendEmailFunc(this.props.t('ownerBlockedDate'), true);
      } else {
        this.setState({
          errorMessage: blockDateResult.message || this.props.t('errorWhileBlocking'),
        });
        setLoaderVisibility(false);
      }
    } else {
      calendarService
        .blockDate(
          moment(blockOffData.fromDateTime).format('YYYY-MM-DD HH:mm:00'),
          moment(blockOffData.toDateTime).format('YYYY-MM-DD HH:mm:00'),
          blockOffData.propertyId,
          note,
          blockOffData.toDateTime,
          blockOffData.stayingMember,
          blockOffData.guests,
          blockOffData.files
        )
        .then(() => {
          this.sendEmailFunc(this.props.t('ownerBlockedDate'), true);
        })
        .catch((error) => {
          this.setState({
            errorMessage: error?.data?.error?.message || this.props.t('errorWhileBlocking'),
          });
          setLoaderVisibility(false);
        });
    }
  }

  showMessagesAndUpdate(blockOffData) {
    if (blockOffData) {
      this.setState({
        errorMessage: blockOffData.message,
      });
    }
    this.validator.showMessages();
    this.forceUpdate();
  }

  ischeckInDisabled() {
    if (!this.state.fromTime.isValid()) {
      return false; // If no valid date/time is selected, don't disable
    }
    const now = moment();
    const fromDateTime = moment(
      `${this.state.fromDate} ${this.state.fromTime.format(environment.timeFormat)}`,
      'YYYY-MM-DD hh:mm A'
    );

    return this.props.selectedReservation && now.isSameOrAfter(fromDateTime);
  }

  render() {
    const { t } = this.props;

    return (
      <div className="block-off-date-form account-overflow property-overflow">
        <div className="form-group">
          <KeyboardDatePicker
            id="inputFromDate"
            format="YYYY-MM-DD"
            value={moment(this.state.fromDate, 'YYYY-MM-DD')}
            onChange={this.onFromDateChange}
            onOpen={this.onDatePickerOpen}
            onMonthChange={this.onCheckinPickerMonthChange}
            minDate={moment(this.getMinDate(), 'YYYY-MM-DD')}
            shouldDisableDate={(day) => this.isCheckinDateDisabled(day)}
            disabled={this.ischeckInDisabled()}
            invalidDateMessage={t('invalidTime')}
            DialogProps={{ className: 'keyboard-date-picker-dialog' }}
            KeyboardButtonProps={{
              'aria-label': t('fromDate'),
            }}
          />
          {this.validator.message(
            'fromDate',
            this.state.fromDate,
            ['required', 'fromDateNotBooked'],
            {
              messages: {
                required: t('common:validationRequired', {
                  field: t('fromDate'),
                }),
                fromDateNotBooked: t('dateSelectionShouldBeInFreeTime'),
              },
            }
          )}
        </div>
        <div className="form-group">
          <KeyboardTimePicker
            mask={moment.locale() === 'en' ? '__:__ _M' : '__:__'}
            value={this.state.fromTime}
            invalidDateMessage={t('invalidTime')}
            format={moment.locale() === 'en' ? environment.timeFormat : environment.timeFormatRU}
            onChange={this.onTimeFromChange}
            ampm={moment.locale() === 'en'}
            disabled={this.ischeckInDisabled()}
            DialogProps={{ className: 'keyboard-time-picker-dialog' }}
          />
          {this.validator.message(
            'fromTime',
            this.state.fromTime,
            [
              'required',
              {
                timeBiggerOrEqual: [this.state.fromDate, this.minFromTime],
              },
            ],
            {
              messages: {
                required: t('common:validationRequired', {
                  field: t('fromTime'),
                }),
                timeBiggerOrEqual: t('common:timeShouldBeBigger', {
                  field: t('fromTime'),
                  minTime: this.minFromTime,
                }),
              },
            }
          )}
        </div>
        <div className="form-group">
          <KeyboardDatePicker
            id="inputToDate"
            format="YYYY-MM-DD"
            value={moment(this.state.toDate, 'YYYY-MM-DD')}
            onChange={this.onToDateChange}
            onOpen={this.onDatePickerOpen}
            onMonthChange={this.onCheckinPickerMonthChange}
            minDate={moment(this.getMinToDate(), 'YYYY-MM-DD')}
            shouldDisableDate={(day) =>
              Boolean(day && this.isToDateBooked(day.format('YYYY-MM-DD')))
            }
            invalidDateMessage={t('invalidTime')}
            DialogProps={{ className: 'keyboard-date-picker-dialog' }}
            KeyboardButtonProps={{
              'aria-label': t('toDate'),
            }}
          />
          {this.validator.message('toDate', this.state.toDate, ['required', 'toDateNotBooked'], {
            messages: {
              required: t('common:validationRequired', {
                field: t('toDate'),
              }),
              toDateNotBooked: t('dateSelectionShouldBeInFreeTime'),
            },
          })}
        </div>
        <div className="form-group">
          <KeyboardTimePicker
            mask={moment.locale() === 'en' ? '__:__ _M' : '__:__'}
            value={this.state.toTime}
            invalidDateMessage={t('invalidTime')}
            onChange={this.onTimeToChange}
            format={moment.locale() === 'en' ? environment.timeFormat : environment.timeFormatRU}
            ampm={moment.locale() === 'en'}
            DialogProps={{ className: 'keyboard-time-picker-dialog' }}
          />

          {this.validator.message(
            'toTime',
            this.state.toTime,
            [
              'required',
              {
                timeLessOrEqual: [this.state.toDate, '11:59 PM'],
              },
            ],
            {
              messages: {
                required: t('common:validationRequired', {
                  field: t('toTime'),
                }),
                timeLessOrEqual: t('common:timeShouldBeLess', {
                  field: t('toTime'),
                  maxTime: '11:59 PM',
                }),
              },
            }
          )}
          {this.shouldExtendReservation() && (
            <div className="invalid-field">{this.props.t('checkoutAfter11')}</div>
          )}
        </div>

        {/* guest and owner staying input */}

        <div className="radio form-group">
          <label htmlFor="stayingMember">{t('stayingMembers')}</label>
          {this.stayingMembersOptions.map((item) => (
            <div className="form-check" key={item.value}>
              <input
                className="form-check-input"
                name="stayingMember"
                type="radio"
                id={`stayingMember${item.value}`}
                onChange={this.onChangeHandler}
                value={item.value}
                checked={Number(this.state.stayingMember) === item.value}
              />
              <label htmlFor={`stayingMember${item.value}`} className="form-check-label">
                {t(item.key)}
              </label>
            </div>
          ))}
          {this.validator.message('stayingMember', this.state.stayingMember, ['required'], {
            messages: {
              required: t('common:validationRequired', {
                field: t('stayingMemberCheckbox'),
              }),
            },
          })}
        </div>

        {/* Guest cards */}
        {Number(this.state.stayingMember) !== 1 && (
          <div className="form-group">
            <label htmlFor="select-bill-option" style={{ fontWeight: '400', color: '#23282c' }}>
              {t('friendsFamilyIdentificationDetails')}
            </label>

            <GuestDetailCard
              onChange={this.handleGuestDetailsChange}
              showErrors={this.state.showGuestErrors}
              initialGuests={this.state.guestDetails}
            />
          </div>
        )}

        {!this.props.selectedReservation ? (
          <div className="radio form-group">
            <label htmlFor="accessCard">{t('accessCardQuestion')}</label>
            {this.accessCardValues.map((value) => (
              <div className="form-check" key={value}>
                <input
                  className="form-check-input"
                  name="accessCard"
                  type="radio"
                  id={`accessCard${value}`}
                  onChange={this.onChangeHandler}
                  value={value}
                  checked={this.state.accessCard === value}
                />
                <label htmlFor={`accessCard${value}`} className="form-check-label">
                  {t(value)}
                </label>
              </div>
            ))}
            {this.validator.message('accessCard', this.state.accessCard, ['required'], {
              messages: {
                required: t('common:validationRequired', {
                  field: t('accessCardCheckbox'),
                }),
              },
            })}
          </div>
        ) : null}
        <div className="form-group">
          <textarea
            name="note"
            className="form-control"
            onChange={this.onChangeHandler}
            value={this.state.note}
            id="note"
            placeholder={t('note')}
          />
          {this.state.errorMessage.length ? (
            <div className="invalid-field">{this.state.errorMessage}</div>
          ) : null}
        </div>

        <button type="submit" onClick={this.onSendClick} className="btn block-date-button">
          {t('submit')}
        </button>
        {this.props.selectedReservation ? (
          <button
            type="submit"
            onClick={this.onCancelReservationClick}
            className="btn block-date-button"
          >
            {t('removeReservation')}
          </button>
        ) : null}
      </div>
    );
  }
}

BlockOffDateForm.contextType = LoaderContext;
